import startCase from 'lodash/startCase';

export const MethodsMixin = {
	methods: {
		startCase,
	},
};
